// Только ветка Errors (~5–8 КБ), а не полные словари: обработчик ошибок нужен
// каждой странице, и импорт messages/{ru,en}.json клал оба словаря (~270 КБ)
// в общий клиентский чанк (KAN-974). В next-intl ветка подмешивается в i18n/request.ts.
import ru from "../../../messages/errors/ru.json";
import en from "../../../messages/errors/en.json";

export type ErrorLocale = "ru" | "en";

interface ErrorsNamespace {
  Stage: Record<string, string>;
  Toast: Record<string, string>;
  Code: Record<string, string>;
  Conflict: Record<string, string>;
}

const MESSAGES: Record<ErrorLocale, ErrorsNamespace> = {
  ru: ru as ErrorsNamespace,
  en: en as ErrorsNamespace,
};

/**
 * Определение локали вне React-контекста (интерсепторы axios, ErrorBoundary,
 * Zod-валидация) — там `useLocale()` из next-intl недоступен.
 */
export function getCurrentLocale(): ErrorLocale {
  if (typeof window === "undefined") return "ru";
  const lang = document.documentElement.lang || navigator.language || "";
  return lang.startsWith("en") ? "en" : "ru";
}

export function getErrorMessages(
  locale: ErrorLocale = getCurrentLocale(),
): ErrorsNamespace {
  return MESSAGES[locale];
}
